import { ReactElement } from 'react';

import { Grid } from '@mui/material';

import Game from './components/Game';
import { GamesProps } from './types';

export default function Games({ games }: GamesProps): ReactElement {
  return (
    <Grid container direction='row' justifyContent='space-between' alignItems='stretch' spacing={2}>
      {games.map((game, index) => (
        <Grid key={index} item xs={12} sm={6} lg={3}>
          <Game game={game} />
        </Grid>
      ))}
    </Grid>
  );
}
